<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>ESG Country - Capitalization</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onSave()">
        <mat-icon>save</mat-icon>
        Save
      </button>
    </div>
  </div>

  <div class="component-box">
    <mat-form-field appearance="fill" class="year-field">
      <mat-label>Year</mat-label>
      <mat-select [(ngModel)]="selectedYear" name="year" (selectionChange)="onYearChange()">
        @for (year of years; track year) {
          <mat-option [value]="year">{{ year }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (!hasYearData) {
      <div class="year-warning">
        <mat-icon>{{ isCarriedForward ? 'info' : 'warning' }}</mat-icon>
        @if (isCarriedForward) {
          <span>There is no data for the selected year. Values are shown from a previous year.</span>
        } @else {
          <span>There is no data for the selected year</span>
        }
      </div>
    }
  </div>

  <table mat-table [dataSource]="entries()" class="capitalization-table">
    <ng-container matColumnDef="countryName">
      <th mat-header-cell *matHeaderCellDef>Country</th>
      <td mat-cell *matCellDef="let entry">{{ entry.countryName }}</td>
    </ng-container>

    <ng-container matColumnDef="isLarge">
      <th mat-header-cell *matHeaderCellDef class="checkbox-col">Large</th>
      <td mat-cell *matCellDef="let entry" class="checkbox-col">
        <mat-checkbox
          [checked]="entry.isLarge"
          (change)="onEntryChange(entry, 'isLarge', $event.checked)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="isMedium">
      <th mat-header-cell *matHeaderCellDef class="checkbox-col">Medium</th>
      <td mat-cell *matCellDef="let entry" class="checkbox-col">
        <mat-checkbox
          [checked]="entry.isMedium"
          (change)="onEntryChange(entry, 'isMedium', $event.checked)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="isSmall">
      <th mat-header-cell *matHeaderCellDef class="checkbox-col">Small</th>
      <td mat-cell *matCellDef="let entry" class="checkbox-col">
        <mat-checkbox
          [checked]="entry.isSmall"
          (change)="onEntryChange(entry, 'isSmall', $event.checked)">
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (entries().length === 0) {
    <div class="empty-state">No countries available for {{ selectedYear }}.</div>
  }
</div>
